import { useContext, useEffect } from 'react';
import {
  CurrentApplicationContext,
  ICurrentApplicationContext,
} from '../contexts/CurrentApplicationContext';
import { isExternalUser } from '../../helpers/Qualifications';

type CurrentApplicationOptions = {
  includeQualifications?: true;
};

export const useCurrentApplication = ({
  includeQualifications,
}: CurrentApplicationOptions = {}): ICurrentApplicationContext => {
  const context = useContext(CurrentApplicationContext);
  const isExternal = isExternalUser();

  const { application, qualifications, loadQualifications } = context;

  useEffect(() => {
    if (
      includeQualifications &&
      application.result &&
      !qualifications.result &&
      !qualifications.loading &&
      !qualifications.error
    ) {
      loadQualifications?.();
    }
  }, [includeQualifications, isExternal, application, qualifications, loadQualifications]);

  return context;
};
